import Controller from './close_when_clicked_outside_controller';

// The legacy `.flex-dropdown-menu` open modifier is the default; a Tailwind-styled menu passes
// its own through `data-dropdown-open-class`.
const DEFAULT_OPEN_CLASS = 'flex-dropdown-menu--open';

export default class extends Controller {
  static classes = ['open'];

  toggle() {
    this._opened = !this._opened;
  }

  open() {
    this._opened = true;
  }

  close() {
    this._opened = false;
  }

  get _opened() {
    return this.element.classList.contains(this.#openClass);
  }

  set _opened(value) {
    this.element.classList.toggle(this.#openClass, value);
  }

  get #openClass() {
    return this.hasOpenClass ? this.openClass : DEFAULT_OPEN_CLASS;
  }
}
